<div class="grid">
  <div style="position: absolute; top: 0; left: 0; width: 100%; background-color: rgba(244,244,244,0.8); z-index: -1">
  </div>
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-mobile title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.models' | transloco}}</p>
            <p>
              {{(mode == 'create' ? 'misc.creation.model' : 'misc.edition.model') | transloco | capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <ng-container *ngIf="!isModelLoading && machineModelForm">
        <form [formGroup]="machineModelForm">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="name">{{'attribute.name' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="name" id="name" pInputText type="text">
              </div>
              <app-validation-errors [control]="machineModelForm.get('name')"></app-validation-errors>
            </div>

            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="col-12 form-field">
                <label for="machineType">{{'attribute.machineType' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-dropdown [placeholder]="'select.machineType' | transloco" styleClass="w-full"
                            [options]="this.machineTypeOptions" [showClear]="true" id="machineType"
                            formControlName="machineType" [autoDisplayFirst]="false" optionLabel="label"
                            optionValue="value">
                </p-dropdown>
              </div>
              <app-validation-errors [control]="machineModelForm.get('machineType')"></app-validation-errors>
            </div>

            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="description">{{'attribute.description' | transloco}}:</label>
              </div>
              <div class="col-12">
                <textarea rows="4" pInputText id="description" formControlName="description" class="w-full"></textarea>
              </div>
              <app-validation-errors [control]="machineModelForm.get('description')"></app-validation-errors>
            </div>

            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>{{ 'model.machineModelFile' | transloco }}: (*)</label>
              </div>
              <div class="col-12">
                <button pButton type="button" class="button-primary ui-button"
                  label="{{ 'common.chooseFile' | transloco }}" icon="pi pi-cloud" iconPos="left"
                  (click)="dispatchClick()"></button>

                <input #fileUploader type="file" accept="image/*"
                  (change)="fileChangeEvent($event)" style="display:none;" />
              </div>
            </div>

            <div class="col-12 md:col-12 lg:col-8">
              <div class="col-12">
                <p-panel [header]=" (!image) ?  ('invalid.noImage' | transloco)  : image.name" [collapsed]="!image">
                  <ng-template pTemplate="icons">
                    <button *ngIf="image" pButton pRipple class="p-button-rounded btn-danger-light" icon="pi pi-trash"
                      (click)="removeImage()"></button>
                  </ng-template>
                  <div *ngIf="imageErrorMessage" class="danger-color mb-2">
                    {{ imageErrorMessage | transloco }}
                  </div>
                  <p *ngIf="imageBase64" class="text-center">
                    <img style="max-width: 100%; max-height: 350px;" [src]="imageBase64"
                         alt="{{ 'attribute.modelImage' | transloco}}"/>
                  </p>
                </p-panel>
              </div>
            </div>

            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <button [label]="'common.cancel' | transloco" [routerLink]="'/models'" pButton class="p-button-danger"
                    iconPos="right"></button>
                  <p-button [label]="(mode == 'create' ? 'common.create' : 'common.save') | transloco"
                    [disabled]="!isValidImage() || !machineModelForm.valid" [loading]="persistingChanges"
                    (onClick)="save()" styleClass="p-button-primary"></p-button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ng-container>

      <ng-container *ngIf="isModelLoading || machineModelForm == null">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="name">{{'attribute.name' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>

          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="machineType">{{'attribute.machineType' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>

          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="description">{{'attribute.description' | transloco}}:</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="5.5rem"></p-skeleton>
            </div>
          </div>

          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>{{ 'model.machineModelFile' | transloco }}: (*)</label>
            </div>
            <div class="col-12">
              <div class="w-15rem">
                <p-skeleton height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>

          <div class="col-12 md:col-12 lg:col-8">
            <div class="col-12">
              <p-skeleton width="100%" height="27rem"></p-skeleton>
            </div>
          </div>

          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <div class="w-7rem">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
                <div class="w-7rem">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
